import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export let introBanner, parallaxSections, parallaxFooter, inviewHeading

introBanner = () => {
  document.fonts.ready.then(() => {
    const tl = gsap.timeline()
    const heading = document.querySelector('[data-anim][data-split]')
    const chars = heading.querySelectorAll('.char')
    const charsArr = gsap.utils.toArray(chars)

    if (!chars.length) return

    heading.style.opacity = 1

    gsap.utils.shuffle(charsArr)

    tl.fromTo(
      charsArr,
      {
        filter: 'blur(4px)',
        scale: 0.8,
        opacity: 0
      },
      {
        opacity: 1,
        duration: 1.2,
        stagger: 0.02,
        scale: 1,
        filter: 'blur(0px)',
        ease: 'power2.out'
      }
    )
  })
}

inviewHeading = () => {
  document.fonts.ready.then(() => {
    const headings = document.querySelectorAll('[data-split][data-inview]')
    const scroller = document.querySelector('.scroll')

    if (!headings) return

    headings.forEach((heading) => {
      const chars = heading.querySelectorAll('.char')
      const charsArr = gsap.utils.toArray(chars)

      gsap.utils.shuffle(charsArr)

      gsap.set(chars, {
        filter: 'blur(4px)',
        scale: 0.8,
        opacity: 0
      })

      gsap.fromTo(
        charsArr,
        {
          filter: 'blur(4px)',
          scale: 0.8,
          opacity: 0
        },
        {
          scrollTrigger: {
            scroller,
            trigger: heading,
            start: 'top 80%',
            end: 'bottom bottom',
            once: true,
            toggleClass: 'is-inview'
          },
          opacity: 1,
          duration: 1.2,
          stagger: 0.02,
          scale: 1,
          filter: 'blur(0px)',
          ease: 'power2.out'
        }
      )
    })
  })
}

parallaxSections = () => {
  if (window.innerWidth <= 650) return 

  const els = document.querySelectorAll('[data-parallax-section]')
  const scroller = document.querySelector('.scroll')

  document.fonts.ready.then(() => {
    els.forEach((el) => {
      gsap.to(el, {
        y: 500,
        ease: 'none',
        opacity: 0.8,
        scrollTrigger: {
          scroller,
          trigger: el,
          start: 'top top',
          end: 'bottom top',
          invalidateOnRefresh: true,
          scrub: 0
        }
      })
    })
  })
}

parallaxFooter = () => {
  const footer = document.querySelector('.footer')
  const inner = document.querySelector('.footer__inner')
  const scroller = document.querySelector('.scroll')

  if (window.innerWidth <= 650) return

  gsap.fromTo(
    inner,
    {
      yPercent: -60,
      scale: 1
    },
    {
      scrollTrigger: {
        scroller,
        trigger: footer,
        start: 'top bottom',
        end: 'bottom bottom',
        // markers: true,
        scrub: true
      },
      yPercent: 0,
      scale: 1
    }
  )
}

export default () => {}
